import { Loader2 } from "lucide-react";

/**
 * Full-viewport loader shown while lazy route chunks load.
 * Prevents the blank flash from <Suspense fallback={null}>.
 */
export const RouteFallback = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Loading page"
    className="min-h-screen w-full flex items-center justify-center bg-background"
  >
    <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
  </div>
);